(() => {
  const initKakaFaq = (root = document) => {
    root.querySelectorAll('[data-kaka-faq]').forEach((section) => {
      if (section.dataset.kakaFaqInitialized === 'true') return;
      section.dataset.kakaFaqInitialized = 'true';

      const singleOpen = section.dataset.singleOpen === 'true';
      if (!singleOpen) return;

      section.querySelectorAll('details[data-kaka-faq-item]').forEach((details) => {
        details.addEventListener('toggle', () => {
          if (!details.open) return;

          section.querySelectorAll('details[data-kaka-faq-item][open]').forEach((opened) => {
            if (opened !== details) opened.removeAttribute('open');
          });
        });
      });
    });
  };

  initKakaFaq();

  document.addEventListener('shopify:section:load', (event) => {
    initKakaFaq(event.target);
  });
})();
